module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.46-196.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.0-rc.46.md
// module id = 640
// module chunks = 373